var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-banner'),_vm._v(" "),_c('statistics',{staticClass:"my-sta"}),_vm._v(" "),_c('home-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }